import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

/**
 * The over-held notice. Deliberately not an error: the service refuses to
 * consult the cached quantity, because after a reverse split a valid backdated
 * sell legitimately exceeds today's count. Blocking here would make that
 * history unrecordable, so this warns and lets the submit through.
 */
export const FieldWarning = styled.span`
  display: block;
  margin-top: ${SPACING.xs}px;
  color: var(--color-warning);
  font-size: var(--text-sm);
`;
